import React from "react";
import { FiTarget, FiEye } from "react-icons/fi";

export default function MissionVision() {
  return (
    <>
      {/* MISSION & VISION */}
      <section className="bg-white py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-8">
          <div className="bg-white p-8 rounded-3xl shadow-xl border border-slate-100">
            <div className="flex items-center gap-4">
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-blue-100 text-trogoBlue">
                <FiTarget className="h-7 w-7" />
              </div>
              <h2 className="text-3xl font-bold text-slate-900">Our Mission</h2>
            </div>
            <p className="mt-6 text-slate-600 text-lg leading-8">
              To revolutionize transportation with a reliable, secure, and
              technology-driven platform that empowers passengers, businesses,
              and transport providers.
            </p>
          </div>
          <div className="bg-white p-8 rounded-3xl shadow-xl border border-slate-100">
            <div className="flex items-center gap-4">
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-orange-100 text-trogoOrange">
                <FiEye className="h-7 w-7" />
              </div>
              <h2 className="text-3xl font-bold text-slate-900">Our Vision</h2>
            </div>
            <p className="mt-6 text-slate-600 text-lg leading-8">
              To become India’s most trusted all-in-one transport ecosystem,
              connecting people, goods, and businesses seamlessly through
              innovation and trust.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
